import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { PublishedOpportunityService } from "@platform-app/app/core/api/services";
import { EMPTY, of, switchMap, throwError } from "rxjs";
import { GetPublishedOpportunitySeatsAvailabilityCalculationType } from "../core/api/models";
import { DateUtility } from "@platform-app/app/shared/common/utilities";

export const enrollmentResolver: ResolveFn<void | null> = (route) => {
  const opportunityId = route.paramMap.get("id");
  const publishedOpportunityService = inject(PublishedOpportunityService);

  if (opportunityId) {
    return publishedOpportunityService
      .getPublishedOpportunity({
        opportunityId: opportunityId,
        body: {
          seatsCalculationType:
            GetPublishedOpportunitySeatsAvailabilityCalculationType.ProvideDates,
          studentId: null,
          seatsAvailabilityStartDate: DateUtility.convertToDateOnlyString(
            new Date(),
          ),
          seatsAvailabilityEndDate: DateUtility.convertToDateOnlyString(
            new Date(),
          ),
        },
      })
      .pipe(
        switchMap((data) =>
          data.availableSeats
            ? of(null) // Null indicates that we can proceed
            : throwError(() => "No available seats, cannot enroll"),
        ),
      );
  } else {
    return EMPTY;
  }
};
